module.exports = __webpack_public_path__ + "assets/fonts/Icon-Arbeitslose.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-Arbeitslose.svg
// module id = 521
// module chunks = 0